import React from "react";
import styled from "styled-components";
import Dropdown from "components/common/ui/Dropdown/Dropdown";
import { InputLabel } from "./FeatureRequestInput";

const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    &:hover {
        background-color: #f0f0f0;
    }
`;

const DropdownButton = styled.button<{ isOpen: boolean; disabled?: boolean }>`
    background: white;
    border: 1px solid rgb(109, 131, 143);
    font-size: 16px;
    font-weight: 400;
    padding: 8px 28px 8px 12px;
    text-align: left;
    width: 100%;
    height: 43px;
    display: block;
    color: rgb(62, 86, 96);
    position: relative;
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        right: 12px;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid currentColor;
        transform: translateY(-50%) ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
        transition: transform 0.2s ease-in-out;
    }
`;

interface FeatureRequestsDropdownProps {
    isOpen: boolean;
    toggle: (isOpen: boolean) => void;
    options: { value: string; label: string }[];
    selectedValue: string;
    onValueChange: (value: string) => void;
    placeholder: string;
    disabled?: boolean;
    fullWidth?: boolean;
    label?: string;
}

const FeatureRequestsDropdown: React.FC<FeatureRequestsDropdownProps> = ({
    isOpen,
    toggle,
    options,
    selectedValue,
    onValueChange,
    placeholder,
    disabled,
    fullWidth,
    label,
}) => {
    const handleSelect = (value: string) => {
        onValueChange(value);
        toggle(false);
    };

    const selectedOption = options.find((option) => option.value === selectedValue);

    return (
        <div>
            {label && <InputLabel>{label}</InputLabel>}
            <Dropdown
                isOpen={isOpen}
                toggle={toggle}
                fullWidth={fullWidth}
                disabled={disabled}
                renderButtonContent={() => (
                    <DropdownButton isOpen={isOpen} disabled={disabled}>
                        {selectedOption?.label || placeholder}
                    </DropdownButton>
                )}
                renderContent={() => (
                    <div>
                        {options.map((option) => (
                            <DropdownItem
                                key={option.value}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.label}
                            </DropdownItem>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};

export default FeatureRequestsDropdown;
